
import Products from '~/components/Products/index.vue'
export default {
  components: { Products },
  middleware: ['returnUrl', 'onlyRedirectProject'],
  async asyncData({ store, route }) {
    const query = route.query
    const filter = {
      page: 1,
      search: '',
      limit: 12,
      type: 2,
      categoryId: -1,
      currency: store.getters['user/getUserIP'].currency,
    }
    if (!isNaN(Number(query.page))) filter.page = query.page
    if (query.q) filter.search = query.q
    if (!isNaN(Number(query.categoryId)))
      filter.categoryId = Number(query.categoryId)
    await store.dispatch('books/GET_BOOKS', filter)
    return {
      products: store.getters['books/getBooks'],
      count: store.getters['books/getBooksCount'],
      page: filter.page,
      pages: Math.ceil(store.getters['books/getBooksCount'] / 12),
      startCount: (filter.page - 1) * 12,
      endCount:
        filter.page * 12 > store.getters['books/getBooksCount']
          ? store.getters['books/getBooksCount']
          : filter.page * 12,
    }
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title: `(${this.count}) ${this.$custom$t('type.books')} | ${
        this.$store.state.settings.title
      }`,
      link: [
        {
          hid: 'icon',
          rel: 'icon',
          type: 'image/x-icon',
          href: this.$store.state.settings.noImage,
        },
      ],
      meta: [
        { hid: 'og-type', property: 'og:type', content: 'website' },
        {
          hid: 'title',
          property: 'title',
          content: `(${this.count}) ${this.$custom$t('type.books')} | ${
            this.$store.state.settings.title
          }`,
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: this.$store.state.settings.title,
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$store.state.settings.contents[
            this.$i18n.locale
          ].home.banner.overview.substring(0, 152),
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content: `(${this.count}) ${this.$custom$t('type.books')} | ${
            this.$store.state.settings.title
          }`,
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.$store.state.settings.contents[
            this.$i18n.locale
          ].home.banner.overview.substring(0, 152),
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content:
            this.$store.state.settings.contents[this.$i18n.locale].seo.home
              .image,
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content:
            this.$store.state.settings.contents[this.$i18n.locale].seo.home.url,
        },
        { hid: 't-type', name: 'twitter:card', content: 'summary_large_image' },
      ],
      script: [
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source === null)
          .map((asettings) => ({
            type: 'text/javascript',
            innerHTML: asettings.value,
          })),
        ...this.$store.state.settings.analyticSettings
          .filter((as) => as.key === 'script' && as.source !== null)
          .map((asettings) => ({
            type: 'text/javascript',
            src: asettings.source,
            innerHTML: asettings.value,
          })),
               ...this.$store.state.settings.contents.customScripts
          .filter((s) => s?.overview !== '-' && s?.overview !== '')
          .map((script) => ({
            type: 'text/javascript',
            innerHTML: script?.overview,
          })),
        ...this.$store.state.settings.contents.customScripts
          .filter((s) => s?.description !== '-' && s?.description !== '')
          .map((script) => ({
            type: 'text/javascript',
            src: script?.description,
            async: true,
            defer: true,
          })),
        ...this.$store.state.settings.contents.googleAnalytics
          .filter((ga) => ga?.title.startsWith('G-'))
          .map((ga) => ({
            type: 'text/javascript',
            src: `https://www.googletagmanager.com/gtag/js?id=${ga?.title}`,
            async: true,
            defer: true,
          })),
        ...this.$store.state.settings.contents.googleAnalytics
          .filter((ga) => ga?.title.startsWith('G-') && ga?.title !== '')
          .map((ga) => ({
            type: 'text/javascript',
            innerHTML: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${ga?.title}');`,
          })),


      ],
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  methods: {
    SET_PAGINATION(page) {
      this.page = page
      this.startCount = (page - 1) * 12
      this.endCount =
        page * 12 > this.$store.getters['books/getBooksCount']
          ? this.$store.getters['books/getBooksCount']
          : page * 12
      this.$store.dispatch('books/GET_BOOKS', {
        page,
        search: '',
        limit: 12,
        type: 2,
        categoryId: -1,
        currency: this.$store.getters['user/getUserIP'].currency,
      })
      document.getElementById('list').scrollIntoView({ behavior: 'smooth' })
    },
  },
}
